'use client';
import { createContext } from 'react';
import { useNonNullishContext } from '../../hooks/use-non-nullish-context.js';

const TabsContext = createContext(null);
TabsContext.displayName = 'TabsContext';
function useTabsContext() {
    return useNonNullishContext(TabsContext);
}

export { TabsContext, useTabsContext };
